// Core imports
import * as React from 'react';

// Components imports
import SubcategoryFilter from 'src/model/subcategoryFilter.model';

// Style and misc imports
import './Filter.scss';
import Checkbox from 'src/components/common/Checkbox';

class Filter extends React.Component<IFilterProps, any> {
  /*
      handleClick
     */
  private handleClick = (event?: any) => {
    event?.preventDefault(); // safe: only runs if event exists
    this.props.action(this.props.filter, 'add', this.props.selectionType);
  };

  public componentDidMount() {
    const storedValue = localStorage.getItem("applianceSelectedCategoryName");
    if (storedValue && this.props.active) {
      this.handleClick(); // no event passed
    }
  }

  public render() {
    const { filter } = this.props;
    localStorage.getItem('applianceSelectedCategoryName')
    return (
      <li className={`filter-check ${this.props.active ? 'active' : ''}`} onClick={this.handleClick}>
        <div className="filter-indicator">
          <></>
        </div>
        {(window.location.pathname === "/ca/fr/" || window.location.pathname === "/ca/fr" || window.location.pathname.includes("/ca/fr/")) && filter.frName!== null 
            ?filter.frName
            :filter.name
        }
      </li>
    );
  }
}

export default Filter;

interface IFilterProps {
  indexKey: number;
  active: boolean;
  action: any;
  filter: SubcategoryFilter;
  selectionType: string;
}

